import React from 'react';
import { Layout, Card, Typography, Space } from 'antd';
import { Outlet } from 'react-router-dom';
import { COLORS } from '../../constants/colors';

const { Content } = Layout;
const { Title, Text } = Typography;

export const AuthLayout: React.FC = () => {
  return (
    <Layout style={{ minHeight: '100vh', background: COLORS.bgLayout }}>
      <Content
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '24px',
        }}
      >
        <Card
          style={{
            width: 420,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          }}
        >
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <div style={{ textAlign: 'center' }}>
              <Title level={3} style={{ color: COLORS.primary, marginBottom: 8 }}>
                NexusInflu
              </Title>
              <Text type="secondary">AI红人营销工作平台</Text>
            </div>
            <Outlet />
          </Space>
        </Card>
      </Content>
    </Layout>
  );
};
